import { render } from "./CoordinatorActions.vue?vue&type=template&id=06d662df"
import script from "./CoordinatorActions.vue?vue&type=script&lang=js"
export * from "./CoordinatorActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__